export default "__VITE_ASSET__a03344f0__"